export default "mutation updateSyllabus($updateInfo: SyllabusUpdateRequest) {\n  updateSyllabus(updateInfo: $updateInfo) \n}";